import { render } from "./RefundTab.vue?vue&type=template&id=cc32e5b4&scoped=true"
import script from "./RefundTab.vue?vue&type=script&lang=js"
export * from "./RefundTab.vue?vue&type=script&lang=js"

import "./RefundTab.vue?vue&type=style&index=0&id=cc32e5b4&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc32e5b4"]])

export default __exports__